import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { Column } from 'angular-slickgrid';
import { BaseCrudComponent, CrudPage, FieldMapperHelper, ICrudService } from '@zendra/shared';
import {
  GetGisProtectedAreaSnapshotsInputDto,
  GisProtectedAreaSnapshotDto,
} from '../proxy/geographic/dtos/gis-protected-area-snapshot/models';
import { GisProtectedAreaInconsistencyPlanningOrchestratorService } from 'orchestrator';
import { Observable, throwError } from 'rxjs';
import {
  GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG,
  GISPROTECTEDAREAINCONSISTENCYONLYINGIS_FIELDS,
} from './gis-protected-area-inconsistency-only-in-gis.config';
import { GisProtectedAreaSnapshotExcelDownloadDto } from 'projects/orchestrator/src/lib/proxy/geographic/dtos/gis-protected-area-snapshot/models';

type GisProtectedAreaInconsistencyRow = GisProtectedAreaSnapshotDto;
type UnsupportedCrudDto = Record<string, never>;

@Component({
  selector: 'lib-gis-protected-area-inconsistency-only-in-gis',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class GisProtectedAreaInconsistencyOnlyInGis extends BaseCrudComponent<
  GisProtectedAreaInconsistencyRow,
  UnsupportedCrudDto,
  UnsupportedCrudDto,
  GisProtectedAreaSnapshotExcelDownloadDto
> {
  private readonly snapshotService = inject(GisProtectedAreaInconsistencyPlanningOrchestratorService);
  private cachedColumns: Column[] | null = null;

  config = GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG;
  fields = GISPROTECTEDAREAINCONSISTENCYONLYINGIS_FIELDS;

  get columns(): Column[] {
    this.cachedColumns ??= FieldMapperHelper.buildColumnsFromFields(
      this.fields,
      this.localizationService,
      this.injector,
    );
    return this.cachedColumns;
  }

  service: ICrudService<
    GisProtectedAreaInconsistencyRow,
    UnsupportedCrudDto,
    UnsupportedCrudDto,
    GisProtectedAreaSnapshotExcelDownloadDto
  > = {
    create: () => this.unsupportedCrudOperation('create'),
    update: () => this.unsupportedCrudOperation('update'),
    deleteByIds: () => this.unsupportedCrudOperation('delete'),
    getList: query =>
      this.snapshotService.getOnlyInGis({ ...query, sorting: query?.sorting || 'Id desc' } as GetGisProtectedAreaSnapshotsInputDto),
    getDownloadToken: () => this.snapshotService.getDownloadToken(),
    getListAsExcelFile: input => {
      const fields = input.fields as string[] | string | undefined;
      return this.snapshotService.getOnlyInGisAsExcelFile({
        ...input,
        fields: typeof fields === 'string' ? fields.split(',').filter(Boolean) : fields,
        sorting: input.sorting || 'Id desc',
      });
    },
  };

  protected prepareUpdateDto(): UnsupportedCrudDto {
    return {};
  }

  protected getEntityName(): string {
    return 'GisProtectedAreaInconsistencyOnlyInGis';
  }

  private unsupportedCrudOperation<T>(operation: string): Observable<T> {
    return throwError(() => new Error(`GIS protected area inconsistencies are read-only; ${operation} is not supported.`));
  }
}
